import { ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationObserver,
    },
    data: () => ({
        validationObserverReady: false,
    }),
    mounted() {
        setTimeout(() => {
            this.validationObserverReady = true;
        }, 10);
    },
};